import React from 'react'
import PropTypes from 'prop-types'
import { GlobalContext, UserContext } from 'components/context'
import { useLogEvent } from 'components/hooks'
import { FormattedDate } from 'components/Dates'

const plainTextToHtml = (txt) => {
  if (!txt) return ''

  return txt.replace(/\n/g, '<br />')
}

const Promotion = ({ t, membership }) => {
  if (!membership) return null

  return (
    <React.Fragment>
      <div className={'referral-code full-width block'}>
        <h2>{ t('pages.referral.code_title') }</h2>
        <div className={'code'}>
          { membership.referral_code }
        </div>
      </div>
      <p
        dangerouslySetInnerHTML={{ __html: plainTextToHtml(membership.referral.presentation) }}
      />
    </React.Fragment>
  )
}

Promotion.propTypes = {
  t: PropTypes.func.isRequired,
  membership: PropTypes.object.isRequired,
}

const MyReferrals = ({ t, myReferrals }) => {
  if (!myReferrals) return null

  return (
    <React.Fragment>
      <h2>{ t('pages.referral.my_referrals')}</h2>
      <table>
        <thead>
          <tr>
            <th>{ t('pages.referral.created_at')}</th>
            <th>{ t('pages.referral.name')}</th>
            <th>{ t('pages.referral.discount')}</th>
            <th>{ t('pages.referral.used')}</th>
            <th>{ t('pages.referral.available')}</th>
          </tr>
        </thead>
        <tbody>
          {
            myReferrals.map((r, i) => (
              <tr key={`referral_${i}`} className={r.credits_available > 0 ? 'available' : 'used'}>
                <td><FormattedDate date={r.created_at} /></td>
                <td>{`${r.first_name} ${r.last_name}`}</td>
                <td>{`${r.discount_percentage}%`}</td>
                <td>{r.credits_used}</td>
                <td>{r.credits_available}</td>
              </tr>
            ))
          }
        </tbody>
      </table>
    </React.Fragment>
  )
}

MyReferrals.propTypes = {
  t: PropTypes.func.isRequired,
  myReferrals: PropTypes.object.isRequired,
}

const Referral = () => {
  const { t } = React.useContext(GlobalContext)
  const { membership } = React.useContext(UserContext)
  useLogEvent('view_referral')

  if (!membership) return null
  console.log('membership', membership)

  return (
    <div id={'referral'}>
      <h1>{ t('pages.referral.title') }</h1>
      <Promotion t={t} membership={membership} />
      <MyReferrals t={t} myReferrals={membership.my_referrals} />
    </div>
  )
}

export default Referral
